var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rtb-stats__widget" },
    [
      _vm.hasRtb
        ? [
            _c("SmartTableWidget", {
              attrs: {
                widget: {
                  tableTitle: _vm.$t("RTB_REJECTION_BREAKDOWN_PANE_TITLE"),
                  iconClass: "fa fa-trophy",
                  locale: _vm.$options.i18n
                },
                "date-range": _vm.rejectionRange,
                "column-defs": _vm.columnSettings.errorsByPublisher,
                "row-data": _vm.errorsByPublisher || [],
                "enable-export": true,
                "export-title": _vm.formatTitleWithCampaignName(
                  "RTB Errors Stats by Publisher"
                ),
                icon: "fa-chevron-down"
              },
              on: { "update-date-range": _vm.updateErrors },
              scopedSlots: _vm._u(
                [
                  {
                    key: "table",
                    fn: function() {
                      return [
                        _vm.loadingErrorBreakdown
                          ? _c("LoadingStatusDisplay", {
                              attrs: { loading: true }
                            })
                          : !_vm.errorsByPublisher.length
                          ? _c("div", { staticClass: "empty-records" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("RTB_REJECTION_BREAKDOWN_PANE_EMPTY")
                                  ) +
                                  "\n        "
                              )
                            ])
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1209753470
              )
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }